<template>
  <transition appear>
    <div data-component="VimeoRoom" id="vimeoRoomWrapperStage" class="room stage">
      <div class="video-select">
        <a href="javascript:;" @click="changeSelectedURL(item)" v-for="item in getCurrentSession.externalLivestreamProviders" :key="item.id">{{ item.title }}</a>
      </div>
      <transition name="el-fade-in" mode="out-in">
        <iframe :src="vimeoLink(selected.url)" :width="vimeoWidth" v-if="selected.type == 0" :height="vimeoHeight" frameborder="0" allowfullscreen allow="autoplay; encrypted-media"></iframe>
        <iframe :width="vimeoWidth" v-if="selected.type == 1" :height="vimeoHeight" frameborder="0" allowfullscreen :src="youtubeLink(selected.url)" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
      </transition>
    </div>
  </transition>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import Player from "@vimeo/player";

export default {
  components: { Player },
  props: {},

  data() {
    return {
      selected: null
    };
  },

  computed: {
    vimeoWidth() {
      return window.innerWidth;
    },
    vimeoHeight() {
      return window.innerHeight;
    },
    getCurrentSession() {
      return this.$store.getters.getCurrentSession;
    },
    getParticipantID() {
      return this.$store.state.participant.item.id;
    }
  },

  mounted() {
    this.selected = this.getCurrentSession.externalLivestreamProviders[0];
  },

  async beforeDestroy() {},

  methods: {
    changeSelectedURL(item) {
      this.selected = item;
    },
    vimeoLink(item) {
      var videoId = item.split("/").pop();
      var vimeoUrl = `https://player.vimeo.com/video/${videoId}`;
      return vimeoUrl;
    },
    youtubeLink(item) {
      var videoId = "";
      if(item.indexOf("?v=") != -1)
      {
        videoId = item.split("?v=").pop();
      }
      else
      {
        videoId = item.split("/").pop();
      }

      var youtubeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      return youtubeUrl;
    }
  }
};
</script>
<style lang="less" scoped>
#vimeoRoomWrapperStage {
  display: flex;
  align-items: center;
  justify-content: center;
  iframe {
    aspect-ratio: 16/9 !important;
    max-width: 80% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/media/VimeoRoom.vue